import React, { useState, useMemo } from "react";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  Checkbox,
} from "@mui/material";
import ActionItems from "../shared/ActionItems";
import TablePaginations from "../shared/TablePaginations";
import { TableWrapper, ActionButtonMain } from "../shared/styles/TableStyles";

const JobsPopupTable = ({
  TableHeadData = [],
  BodyData = [],
  Hasaction = true,
}) => {
  const [selectedItems, setSelectedItems] = useState([]);

  const [sortConfig, setSortConfig] = useState({
    key: "",
    direction: "asc",
  });

  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key: key, direction: direction });
  };

  const sortedData = useMemo(() => {
    const sortedArray = [...BodyData];

    sortedArray.sort((a, b) => {
      const aValue = a[sortConfig.key];
      const bValue = b[sortConfig.key];

      if (typeof aValue === "string" && typeof bValue === "string") {
        return sortConfig.direction === "asc"
          ? aValue.localeCompare(bValue)
          : bValue.localeCompare(aValue);
      }

      return sortConfig.direction === "asc" ? aValue - bValue : bValue - aValue;
    });

    return sortedArray;
  }, [BodyData, sortConfig]);

  // ===== this is for the action buttons

  const [anchorEl, setAnchorEl] = useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  // this is for the   paginations

  const rowsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);

  const startIndex = (currentPage - 1) * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  const pagedData = sortedData.slice(startIndex, endIndex);

  const handleChangePage = (page) => {
    setCurrentPage(page);
  };

  const handleCheckboxChange = (row) => {
    if (selectedItems.includes(row)) {
      setSelectedItems(selectedItems.filter((item) => item !== row));
    } else {
      setSelectedItems([...selectedItems, row]);
    }
  };

  return (
    <TableWrapper className="TableWrapper">
      <TableContainer className="TableContainer">
        <Table>
          <TableHead>
            <TableRow className="table_head">
              {TableHeadData.map((value, index) => (
                <TableCell
                  key={value.title}
                  colSpan={
                    index === TableHeadData.length - 1 && Hasaction == true
                      ? 2
                      : 1
                  }
                >
                  <TableSortLabel
                    active={sortConfig.key === value.val}
                    direction={sortConfig.direction}
                    onClick={() => handleSort(value.val)}
                    IconComponent={ArrowDropUpIcon}
                  >
                    {value.title}
                  </TableSortLabel>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody className="table_body">
            {pagedData.map((row, index) => (
              <TableRow key={index} className={`table__row ${row}`}>
                {TableHeadData.map((head, cellIndex) => {
                  if (head.val === "checkbox") {
                    return (
                      <TableCell key={cellIndex} padding="checkbox">
                        <Checkbox
                          color="primary"
                          checked={selectedItems.includes(row)}
                          onChange={() => handleCheckboxChange(row)}
                        />
                      </TableCell>
                    );
                  } else {
                    return (
                      <TableCell key={cellIndex} className={`${head.val}`}>
                        {head.val === "status" ? (
                          <span
                            className={`statusSpan status_${row[
                              head.val
                            ].toLowerCase()}`}
                          >
                            {row[head.val]}
                          </span>
                        ) : (
                          row[head.val]
                        )}
                      </TableCell>
                    );
                  }
                })}
                {Hasaction && (
                  <TableCell style={{ paddingLeft: "0px" }}>
                    <ActionButtonMain onClick={handleClick}>
                      <MoreHorizIcon />
                    </ActionButtonMain>
                    <ActionItems
                      id={id}
                      open={open}
                      handleClose={handleClose}
                      anchorEl={anchorEl}
                    />
                  </TableCell>
                )}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {sortedData?.length > rowsPerPage && (
        <TablePaginations
          currentPage={currentPage}
          rowsPerPage={rowsPerPage}
          sortedData={sortedData}
          handleChangePage={handleChangePage}
        />
      )}
    </TableWrapper>
  );
};

export default JobsPopupTable;
